import { useRouter } from "next/router";
import { DropDown, MenuItemLabel, NavItem, Root } from "./styles";
import Dropdown from "../../icons/Dropdown";
import React, { useEffect, useState } from "react";
import { ITopMenuItem } from "../../../dto";
import { useShowPageLayoutContext } from "contexts/ShowPageLayoutContext";
import { useMediaQuery } from "react-responsive";
import { DateTime } from "luxon";
import useLeaderboardTotalPrize from "hooks/leaderboards/useLeaderboardTotalPrize";
import useActiveTournamentsCount from "hooks/tournaments/public/useAnyActiveTournaments";
import useActiveChallengesCount from "hooks/challenges/api/useAnyActiveChallenges";

const NavLink: React.FC<{
  item: ITopMenuItem;
  itemKeys: string[];
  setItemKeys: React.Dispatch<React.SetStateAction<string[]>>;
  onNavItemClick?: () => void;
}> = ({ item, itemKeys, setItemKeys, onNavItemClick }) => {
  const isTablet = useMediaQuery({
    query: "(min-width: 480px) and (max-width: 1399px)",
  });

  const { data: activeTCount } = useActiveTournamentsCount();
  const { data: activeCCount } = useActiveChallengesCount();

  const { data: leaderboardsTotalPrize } = useLeaderboardTotalPrize();

  const router = useRouter();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { setShowNavSidebar } = useShowPageLayoutContext();

  useEffect(() => {
    setIsOpen(itemKeys.includes(item.name));
  }, [itemKeys, item.name]);

  return (
    <Root>
      <NavItem
        href={item.href ?? "/"}
        data-active={item.href === router.pathname}
        data-mobile-only={item.isMobileOnly ?? false}
        data-desktop-only={item.isDesktopOnly ?? false}
        selected={isOpen}
        data-has-dropdown={!!item.items?.length}
        onClick={(e) => {
          e.preventDefault();
          if (item.items?.length) {
            if (itemKeys.includes(item.name)) {
              setItemKeys((prev) => prev.filter((itemKey) => itemKey !== item.name));
            } else {
              setItemKeys((prev) => [...prev, item.name]);
            }
          } else if (item.href) {
            router.push(item.href);
            if (isTablet) setShowNavSidebar(false);
            if (onNavItemClick) onNavItemClick();
          }
        }}
      >
        {item.image}
        {item.name}
        {item.items?.length && (
          <Dropdown
            style={{
              marginLeft: "auto",
              transition: "transform 0.3s",
              transform: isOpen ? "rotate(180deg)" : "none",
            }}
          />
        )}
        {item.name === "Leaderboards" && !!leaderboardsTotalPrize && (
          <MenuItemLabel itemName="Leaderboards">{`$${leaderboardsTotalPrize}`}</MenuItemLabel>
        )}

        {item.name === "Tournaments" && (
          <MenuItemLabel itemName="Tournaments">{activeTCount}</MenuItemLabel>
        )}

        {item.name === "Challenges" && item.image && (
          <MenuItemLabel itemName="Tournaments">{activeCCount}</MenuItemLabel>
        )}

        {["All bonuses", "Calendar"].includes(item.name) && (
          <MenuItemLabel itemName={item.name}>
            {item.name === "All bonuses"
              ? "Free"
              : item.name === "Calendar"
                ? `Day ${DateTime.utc().day}`
                : null}
          </MenuItemLabel>
        )}
      </NavItem>
      <DropDown show={isOpen}>
        {item.items?.map((subItem, index) => (
          <NavLink
            key={`${item.name}_${index}`}
            item={subItem}
            itemKeys={itemKeys}
            setItemKeys={setItemKeys}
            onNavItemClick={onNavItemClick}
          />
        ))}
      </DropDown>
    </Root>
  );
};

export default NavLink;
